// @ts-check
/**
 * @typedef {Object} ffSliderCustomProperties
 * @property {Function} ffRestrains Removes empty spaces generated for the arrows and dots if they aren't being displayed.
 * @property {Function} ffResizeSlides
 * @property {() => Promise<void>} ffInit
 * @property {{
 *   update: Function,
 *   destroy: Function,
 *   updateSlides: Function,
 *   appendSlide: Function,
 *   removeAllSlides: Function,
 *   removeSlide: Function,
 *   on: (
 *     eventName:
 *       | "activeIndexChange"
 *       | "afterInit"
 *       | "beforeDestroy"
 *       | "beforeInit"
 *       | "beforeLoopFix"
 *       | "beforeResize"
 *       | "beforeSlideChangeStart"
 *       | "beforeTransitionStart"
 *       | "breakpoint"
 *       | "changeDirection"
 *       | "click"
 *       | "destroy"
 *       | "doubleClick"
 *       | "doubleTap"
 *       | "fromEdge"
 *       | "init"
 *       | "lock"
 *       | "loopFix"
 *       | "momentumBounce"
 *       | "observerUpdate"
 *       | "orientationchange"
 *       | "progress"
 *       | "reachBeginning"
 *       | "reachEnd"
 *       | "realIndexChange"
 *       | "resize"
 *       | "setTransition"
 *       | "setTranslate"
 *       | "slideChange"
 *       | "slideChangeTransitionEnd"
 *       | "slideChangeTransitionStart"
 *       | "slideNextTransitionEnd"
 *       | "slideNextTransitionStart"
 *       | "slidePrevTransitionEnd"
 *       | "slidePrevTransitionStart"
 *       | "slideResetTransitionEnd"
 *       | "slideResetTransitionStart"
 *       | "sliderFirstMove"
 *       | "sliderMove"
 *       | "slidesGridLengthChange"
 *       | "slidesLengthChange"
 *       | "slidesUpdated"
 *       | "snapGridLengthChange"
 *       | "snapIndexChange"
 *       | "tap"
 *       | "toEdge"
 *       | "touchEnd"
 *       | "touchMove"
 *       | "touchMoveOpposite"
 *       | "touchStart"
 *       | "transitionEnd"
 *       | "transitionStart"
 *       | "unlock"
 *       | "update",
 *     callback: Function
 *   ) => void
 * }} ffSwiper
 *
 * @typedef {ffSliderCustomProperties & HTMLElement} FfSlider
 */

if (!customElements.get("ff-slider")) {
  class FfSlider extends HTMLElement {
    constructor() {
      super();

      this.ffSwiperSelector = this.dataset.ffSwiperSelector;

      /**
       * @type {HTMLElement}
       */
      this.ffSlider = (() => {
        /**
         * @type {HTMLElement | null}
         *`
         */
        const ffSlider = this.querySelector(this.ffSwiperSelector || "");

        if (ffSlider) {
          return ffSlider;
        } else {
          throw new Error(
            `There wasn't found an element with the selector: '${this.ffSwiperSelector}, which is needed for the creation of the swiper instance.`
          );
        }
      })();

      this.ffInit();
    }

    ffInit = () => {
      this.ffInitBaseDinamic();
    };

    /**
     * This case was created for the cart drawer, which was fetching the slider html, so the configuration script was not being executed.
     * @param {Boolean} ffScriptAppended 
     */
    ffInitBaseDinamic = (ffScriptAppended = false) => {
      const params = ffSwiperConfigurations[this.id];

      if (params) {
        this.ffSwiper = new Swiper(this.ffSwiperSelector, params);
        this.classList.remove("ff-slider-uninitialized");
      } else if (!ffScriptAppended) {
        const scriptNotExecuted = document.getElementById(this.id + "--config");
        const scriptToExecute = document.createElement("script");
        //@ts-ignore
        scriptToExecute.textContent = scriptNotExecuted?.textContent;
        document.body.append(scriptToExecute);
        ffScriptAppended = true;
        requestAnimationFrame(this.ffInitBaseDinamic(ffScriptAppended));
      } else {
        requestAnimationFrame(this.ffInitBaseDinamic(ffScriptAppended));
        console.error("config not found")
      }

    }
  }

  customElements.define("ff-slider", FfSlider);
}
